// extracted by mini-css-extract-plugin
export default {"cardList":"promptingEvent_cardList__Mmw-G","eventCard":"promptingEvent_eventCard__3HOLg"};